var boostPFSInstantSearchConfig={search:{suggestionMobileStyle:"style2"}};!function(){BoostPFS.inject(this),SearchInput.prototype.customizeInstantSearch=function(t,n,o){}}();

InstantSearchApi.afterCallAsync = function (result, callbackInstantSearchApi) {
  /* Call 3rd party api */
  if (typeof window.Locksmith === 'object' && result.products.length > 0) {
    var URLs = [],
      URLsCollection = [],
      totalUrls = [],
      grantedAccess = [],
      grantedAccessCollection = [];
    //Create an array of products URLs
    for (var i = 0; i < result.products.length; i++) {
      URLs.push('/products/' + result.products[i].handle);
    }
    for (var i = 0; i < result.collections.length; i++) {
      URLsCollection.push('/collections/' + result.collections[i].handle);
    }
    totalUrls = URLs.concat(URLsCollection);
    jQ.ajax({
      method: 'GET',
      url: '/apps/locksmith/api/resources',
      data: { urls: totalUrls, },
      timeout: 1500,
      async: false,
      success: function (response) {
        try {
          var resources = JSON.parse(response);
          for (var i = 0; i < URLs.length; i++) {
            //Checks that the response exists
            if (resources[URLs[i]]) {
              //Checks that the access of the product has been granted
              if (typeof resources[URLs[i]] !== 'undefined' && (!resources[URLs[i]].hide_resource || resources[URLs[i]].manual_lock)) {
                //If the product is accessible add it to the array of the products
                grantedAccess.push(result.products[i])
              }
            }
          }
          //Change array of products
          result.products = grantedAccess;
          //Same for collections
          for (var i = 0; i < URLsCollection.length; i++) {
            //Checks that the response exists
            if (resources[URLsCollection[i]]) {
              //Checks that the access of the product has been granted
              if (!resources[URLsCollection[i]].hide_resource || resources[URLsCollection[i]].manual_lock) {
                //If the product is accessible add it to the array of the products
                grantedAccessCollection.push(result.collections[i])
              }
            }
          }
          //Change array of collections
          result.collections = grantedAccessCollection;
          /* Build everything after getting instant search data */
          callbackInstantSearchApi(result);
        } catch (error) {
          console.error(error);
          callbackFilterApi(result);
        }
      },
      error: function () {
        /* Build everything after getting instant search data */
        callbackInstantSearchApi(result);
      },
    });
  } else {
    callbackInstantSearchApi(result);
  }
}